import { ListItem, ListItemButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import NotificationNumberBadge from './notification-number-badge';
import type { ListElement } from '@/components/organizations/active-organization-menu/index.tsx';

interface ActiveOrganizationMenuItemProps {
  listElement: ListElement;
  onClick: () => void;
  isSelected: boolean;
}

export default function ActiveOrganizationMenuItem({
  listElement,
  onClick,
  isSelected,
}: ActiveOrganizationMenuItemProps) {
  return (
    <ListItem disablePadding onClick={onClick}>
      <ListItemButton
        sx={{
          pl: 1.5,
          pr: 0.5,
          py: 0,
          minHeight: 36,
          bgcolor: 'transparent',
          borderRadius: 0,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 20,
            mr: 0.75,
          }}
        >
          <Box
            sx={{
              'display': 'flex',
              'alignItems': 'center',
              '& svg': {
                fontSize: '1.0rem',
                width: '1.0rem',
                height: '1.0rem',
                color: isSelected ? 'primary.main' : 'inherit',
              },
            }}
          >
            {listElement.icon}
          </Box>
        </ListItemIcon>
        <NotificationNumberBadge color="primary" badgeContent={listElement.count}>
          <ListItemText
            primary={listElement.text}
            primaryTypographyProps={{
              variant: 'subtitle1',
              sx: {
                color: isSelected ? 'primary.main' : 'inherit',
              },
            }}
            sx={{
              mx: 0.5,
            }}
          />
        </NotificationNumberBadge>
      </ListItemButton>
    </ListItem>
  );
}
